import { env } from "@/env";

export const Umami = () => {
  return (
    <>
      {process.env.NEXT_PUBLIC_UMAMI_URL && (
        <script
          async
          src={`${process.env.NEXT_PUBLIC_UMAMI_URL}/script.js`}
          data-website-id={process.env.NEXT_PUBLIC_UMAMI_ID}
          type="text/javascript"
        ></script>
      )}
    </>
  );
};

export const Plausible = () => {
  return (
    <>
        <script
          defer
          data-domain={env.NEXT_PUBLIC_PLAUSIBLE_DOMAIN}
          src={`${env.NEXT_PUBLIC_PLAUSIBLE_URL}/js/script.file-downloads.hash.outbound-links.pageview-props.revenue.tagged-events${process.env.NODE_ENV === "production" ? "" : ".local"}.js`}
        />
        <script
          dangerouslySetInnerHTML={{
            __html: `
              window.plausible = window.plausible || function() {
                (window.plausible.q = window.plausible.q || []).push(arguments)
              }
            `,
          }}
        />
    </>
  );
};
